/* Court Vibes, 17.09.2026.
   Die eigenen Filterknoepfe (.cv-chip) stehen ausserhalb des Produktbereichs.
   Beim Klick filtert das Theme per JavaScript nach und tauscht die Knopfreihe
   gegen serverseitig gerendertes HTML aus. Darin markiert Liquid nur Links
   OHNE Fragezeichen, deshalb blieb die gruene Markierung auf "Alle" stehen,
   obwohl gefiltert war. Gemessen am 17.09.2026 auf /collections/personalisieren.

   Diese Datei setzt die Markierung nach jeder Adressaenderung neu. Der
   Vergleich laeuft ueber Pfad UND den Parameter filter.p.product_type,
   beides zusammen. Der Pfad muss mit, weil die Knoepfe auf /collections/all
   und in den Serien auf verschiedene Kollektionen ohne Fragezeichen zeigen.
   Ohne Pfadvergleich waeren dort alle Knoepfe gleichzeitig gruen.
   Andere Filter wie die Farbe werden bewusst ignoriert, sie sollen die
   Markierung der Produktart nicht aufheben.

   Der Zeitversatz ueber setTimeout ist Absicht, er schiebt die Markierung
   hinter den synchronen Austausch der Knopfreihe. Ohne ihn gewinnt das
   nachgelieferte Server-HTML.

   Faellt die Datei aus, ist nur die Markierung wieder statisch, es geht
   nichts kaputt.
   Probe im Browser:
   getComputedStyle(document.documentElement).getPropertyValue('--cv-filterknoepfe') */
(function () {
  function schluessel(adresse) {
    var a = document.createElement('a');
    a.href = adresse;
    var typ = null;
    try {
      typ = new URLSearchParams(a.search).get('filter.p.product_type');
    } catch (e) {
      typ = null;
    }
    var pfad = a.pathname.replace(/\/+$/, '');
    return pfad + '|' + (typ === null ? '' : typ);
  }

  function markierungSetzen() {
    var knoepfe = document.querySelectorAll('.cv-chip');
    if (!knoepfe.length) return;
    var jetzt = schluessel(window.location.href);
    for (var i = 0; i < knoepfe.length; i++) {
      var k = knoepfe[i];
      var ziel = k.getAttribute('href');
      if (!ziel) continue;
      k.classList.toggle('cv-chip--aktiv', schluessel(ziel) === jetzt);
    }
  }

  function anstossen() {
    window.setTimeout(markierungSetzen, 0);
  }

  ['pushState', 'replaceState'].forEach(function (name) {
    var original = history[name];
    if (typeof original !== 'function') return;
    history[name] = function () {
      var ergebnis = original.apply(this, arguments);
      anstossen();
      return ergebnis;
    };
  });

  window.addEventListener('popstate', anstossen);
  document.addEventListener('DOMContentLoaded', markierungSetzen);
  markierungSetzen();
  document.documentElement.style.setProperty('--cv-filterknoepfe', 'on');
})();
